import { render } from "./PlatformPage.vue?vue&type=template&id=25de6415&scoped=true"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"

import "./PlatformPage.vue?vue&type=style&index=0&id=25de6415&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de6415"]])

export default __exports__